export const getAbsLinkWithCurrentOrigin = (relPath) => `${window.location.origin}${relPath}`;
